export default __webpack_public_path__ + "static/media/leave-dark.dcbfbf17.svg";